import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const EditOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="m21.41 4.89-2.36-2.36a1.56 1.56 0 0 0-1.11-.46c-.4 0-.8.15-1.11.46l-1.29 1.29L4.8 14.55l-.98 4.73c-.09.45.31.9.76.9.05 0 .09 0 .14-.01l4.64-.97L20.15 8.41l-.02-.02 1.29-1.29c.61-.61.61-1.6 0-2.21h-.01ZM8.55 17.73l-2.9.61.62-2.99 9.26-9.26 2.33 2.33-9.31 9.31ZM18.98 7.27l-2.32-2.32 1.27-1.27 2.34 2.29-1.29 1.29v.01Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default EditOutlined
